import { createContext, useContext } from 'react';

export const mosaicContext = createContext(false);

export const useMosaicContext = () => useContext(mosaicContext);
